import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import ElementUI from 'element-ui'
import App from '../views/App.vue'
import store from './store'
import {PAGE_TITLE, router} from './router'
import VueI18n from 'vue-i18n'
import i18nMap from './i18n/i18nMapLoader'

Vue.use(VueI18n)
Vue.use(ElementUI)
moment.locale('zh-cn')

/**
 * 国际化
 */
const i18n = new VueI18n({
  locale: 'zh',
  messages: i18nMap
})

/**
 * 处理文字显示
 */
Vue.filter('deal-words', value => {
  let num
  if (value) {
    num = parseInt(value)
    if (num > 10000) {
      num = `${num / 10000}万`
    }
  } else {
    num = 0
  }
  return `${num}字`
})

/**
 * 处理粉丝数量
 */
Vue.filter('formatNumber', value => {
  let num
  if (value) {
    num = parseInt(value)
    if (num > 100000000) {
      num = `${Math.round(num / 10000000)/10}亿`
    } else if (num > 10000) {
      num = `${Math.round(num / 1000)/10}万`
    }
  } else {
    num = 0
  }
  return `${num}`
})

/**
 * 处理对象调用，避免数据问题造成页面无法加载
 */
Vue.filter('getNoWarnObjValue', variable => {
  var variableArray = variable.split('.');
  var currentString = '';
  for(var index = 0; index < variableArray.length; index++) {
    var value = variableArray[index];
    index? currentString += '.' + value:currentString += value;
    try {
      if(!eval(currentString)) {
        return undefined;
      }
    } catch (e) {
      console.log(index);
      return undefined;
    }
  }
  return eval(currentString);
});

/**
 * 处理音频时间显示
 */
Vue.filter('format-audio-time', time => {
  const formatNumber = (n) => {
    n = n.toString()
    return n[1]
            ? n
            : `0${n}`
  }
  let mm = formatNumber(parseInt(parseInt(time) / 60))
  let ss = formatNumber(parseInt(parseInt(time) % 60))
  return `${mm}:${ss}`
})
/**
 * 格式化时间
 */
Vue.filter('format-date', (date, format) => {
  return moment(date).format(format)
})

let currentUrl

// 页面权限管理
router.beforeEach((to, from, next) => {
  next();
});
/**
 * [title 页面title]
 * @type {[type]}
 */
router.afterEach((to, from) => {
  window.scroll(0, 0)
  currentUrl = to.fullPath
  window.document.title = PAGE_TITLE[to.name] || '有声化平台'
})

/**
 * 添加全局拦截
 */
axios.interceptors.response.use((result) => {
  const code = parseInt(result.data.code)
  const LOGIN_URL = store.state.LOGIN_URL
  const host = store.state.HOST
  switch (code) {
    case 411:
      window.location.href = `${LOGIN_URL}?fromUri=${host}${currentUrl}`
      break
  }
  return result
})

const app = new Vue({
  i18n,
  router,
  store,
  ...App
})
export {app, router}



// WEBPACK FOOTER //
// ./src/app.js